import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AppModeService {
  readonly isEmbedded = signal(false);
  readonly isPreview = signal(false);

  constructor() {
    this.detectEmbedMode();
    this.detectPreviewMode();
  }

  /**
   * Detecta si la app está EMBEBIDA en:
   * - iframe web
   * - Android WebView
   * - iOS WebView (WKWebView)
   */
  private detectEmbedMode(): void {
    const ua = navigator.userAgent || '';

    // Android WebView usualmente incluye "wv"
    const isAndroidWebView = ua.includes('wv') || ua.includes('Android') || ua.includes('Version/');

    // iOS WebView detection
    let isIOSWebView = false;
    try {
      // Si está en iframe: window.self !== window.top
      isIOSWebView = window.self !== window.top;
    } catch {
      // Si da error de CORS → seguro está embebido
      isIOSWebView = true;
    }

    const embedded = isAndroidWebView || isIOSWebView;

    this.isEmbedded.set(embedded);
  }

  /**
   * Detecta el PREVIEW MODE por parámetros URL:
   * https://host.com/embed/lines?preview=1&token=xxxx
   * También persiste el flag en localStorage para sobrevivir redirects
   * de pasarelas de pago (PSE/Bancolombia) que no preservan query params.
   */
  private detectPreviewMode(): void {
    const params = new URLSearchParams(window.location.search);
    if (params.has('preview')) {
      localStorage.setItem('sc-preview-mode', '1');
      this.isPreview.set(true);
      return;
    }
    // Restore preview mode after gateway redirect.
    // sc-preview-mode is only written when ?preview= is in the URL (never in
    // real WebView/iframe flows), so this combination is safe even when
    // isEmbedded() fires a false-positive on Android browser UAs.
    const wasPreview = localStorage.getItem('sc-preview-mode') === '1'
      && !!localStorage.getItem('sc-token-dev');
    this.isPreview.set(wasPreview);
  }

  clearPreviewMode(): void {
    localStorage.removeItem('sc-preview-mode');
    this.isPreview.set(false);
  }
}
